import type { FeatureManifest } from '../registry.js';

/** OVL-09 reward received (generic) and MT-06.2 streak milestones. */
export default {
  id: 'rewards',
  art: ['rare'],
  provides: ['rewardReceived', 'streakMilestone'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
